var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.suggestions.length)?_c('div',{staticClass:"followup-bubbles"},_vm._l((_vm.suggestions),function(q,idx){return _c('button',{key:idx,staticClass:"followup-bubble",class:{ 'followup-bubble--dark': _vm.isDarkMode },on:{"click":function($event){return _vm.$emit('select', q)}}},[_vm._v(" "+_vm._s(q)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }